import { useContext } from 'react';
import { AvailabilitySocketContext } from './AvailabilitySocketProvider';

const useAvailabilitySocket = () => useContext(AvailabilitySocketContext);

export default useAvailabilitySocket;
